import classNames from 'classnames';
import React, { useRef } from 'react';

import { createCalendar } from '@internationalized/date';

import { useDateField } from '@react-aria/datepicker';
import { useLocale } from '@react-aria/i18n';

import { useDateFieldState } from '@react-stately/datepicker';
import type { DatePickerFieldProps } from '@react-stately/datepicker';

import { DatePickerSegment } from '../date-picker-segment';

interface IProps extends Omit<DatePickerFieldProps, 'locale' | 'createCalendar'> {
  id?: string;
  inputClassName?: string;
}

export const DatePickerField: React.FC<IProps> = (props) => {
  const { isDisabled, isReadOnly, isRequired, inputClassName = '' } = props;
  const ref = useRef(null);
  const { locale } = useLocale();
  const state = useDateFieldState({
    ...props,
    locale,
    createCalendar
  });

  const { fieldProps } = useDateField(props, state, ref);

  const className = React.useMemo(() => {
    return classNames('datepicker-segments-style', inputClassName);
  }, [inputClassName]);

  const segments = React.useMemo(() => {
    return state.segments.map((segment, i) => (
      <DatePickerSegment
        key={i}
        id={props.id}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        isRequired={isRequired}
        segment={segment}
        state={state}
      />
    ));
  }, [state.segments]);

  return (
    <div {...fieldProps} className={className} ref={ref}>
      {segments}
    </div>
  );
};
